import { colorArtNotSelected, colorArtSelected } from '@/data/colors';
import { cm } from '@/data/scales';
import { useStore } from '@/store';
import { ArtMesh, DataRow } from '@/types';
import { ThreeEvent } from '@react-three/fiber';
import React, { useEffect, useRef } from 'react';
import gsap, { Sine } from 'gsap';
import * as THREE from 'three';
interface IArtProps {
  datum: DataRow;
}
/**
 * @description
 * individual collection of art
 * */
const Art: React.FC<IArtProps> = ({ datum }) => {
  const refMesh = useRef<ArtMesh>();
  const setArtId = useStore((s) => s.setArtId);
  const getArt = useStore((s) => s.getArt);
  const setMesh = useStore((s) => s.setMesh);
  const selected = getArt(datum.order)?.selected;
  const sortBy = useStore((s) => s.sortBy);
  const setClickable = useStore((s) => s.setClickable);
  const sortDuration = 1;

  useEffect(() => {
    const mesh = refMesh.current;
    if (mesh?.position) {
      if (sortBy === 'area') {
        // mesh.position.set(cm(datum.sizeRank * 4), 0, 0);
        gsap.to(mesh.position, {
          x: cm(datum.sizeRank * 4),
          y: 0,
          z: 0,
          duration: sortDuration,
          ease: Sine.easeInOut,
        });
      }
      if (sortBy === 'year') {
        // mesh.position.set(cm(datum.yearRank * 4), 0, 0);
        gsap.to(mesh.position, {
          x: cm(datum.yearRank * 4),
          y: 0,
          z: 0,
          duration: sortDuration,
          ease: Sine.easeInOut,
        });
      }
    }
  }, [sortBy]);

  useEffect(() => {
    if (!selected) {
      const mesh = refMesh.current;
      if (mesh) {
        // mesh.material.color.set(colorArtNotSelected);
        const targetColor = new THREE.Color(colorArtNotSelected);
        gsap.to(mesh.material.color, {
          r: targetColor.r,
          g: targetColor.g,
          b: targetColor.b,
        });
        gsap.to(mesh.material, { opacity: 0.3 });
      }
    }
  }, [selected]);

  const onClick = (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation();
    setArtId(datum.order);
    const mesh = refMesh.current;
    if (mesh) {
      // mesh.material.color.set(colorArtSelected);
      const targetColor = new THREE.Color(colorArtSelected);
      gsap.to(mesh.material.color, {
        r: targetColor.r,
        g: targetColor.g,
        b: targetColor.b,
      });
      gsap.to(mesh.material, { opacity: 1 });
    }
  };

  useEffect(() => {
    const mesh = refMesh.current;
    // bind mesh to data
    if (mesh) setMesh(datum.order, mesh);
  }, []);

  return (
    <>
      <mesh
        ref={refMesh}
        // artThickness = 1cm
        position={[cm(datum.sizeRank * 4), 0, 0]}
        onClick={onClick}
        onPointerOver={() => setClickable(true)}
        onPointerOut={() => setClickable(false)}
      >
        <boxGeometry args={[cm(1), cm(datum.sizeY), cm(datum.sizeX)]} />
        <meshStandardMaterial
          color={colorArtNotSelected}
          transparent
          opacity={0.3}
        />
      </mesh>
    </>
  );
};

export default Art;
